(function () {
  if (window.__chaskiHome) return;
  window.__chaskiHome = true;

  // Hero: size the tagline so it spans exactly the width of the "Chaski Cacao" title.
  function fitHero() {
    document.querySelectorAll('[data-ch-hero]').forEach(function (el) {
      var t = el.querySelector('[data-ch-tagline]'), h = el.querySelector('[data-ch-title]');
      if (!t || !h) return;
      var base = window.matchMedia('(max-width:767px)').matches ? 20 : 34;
      t.style.fontSize = base + 'px';
      var tw = t.getBoundingClientRect().width, hw = h.getBoundingClientRect().width;
      if (tw && hw) t.style.fontSize = (base * hw / tw) + 'px';
    });
  }

  // Shop carousel arrows (mobile).
  function updateArrows(sec) {
    var g = sec.querySelector('[data-ch-shop-track]');
    if (!g) return;
    var p = sec.querySelector('[data-ch-shop-prev]'), n = sec.querySelector('[data-ch-shop-next]');
    if (p) p.disabled = g.scrollLeft <= 4;
    if (n) n.disabled = g.scrollLeft + g.clientWidth >= g.scrollWidth - 4;
  }

  document.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-ch-faq-q]'))) {
      var item = b.closest('.ch-faq__item'), list = item.parentNode, open = item.classList.contains('is-open');
      list.querySelectorAll('.ch-faq__item.is-open').forEach(function (i) {
        i.classList.remove('is-open');
        i.querySelector('[data-ch-faq-q]').setAttribute('aria-expanded', 'false');
      });
      if (!open) { item.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
    } else if ((b = e.target.closest('[data-ch-faq-more]'))) {
      var sec = b.closest('.ch-faq'), all = sec.classList.toggle('is-all');
      if (!all) sec.querySelectorAll('.ch-faq__item.is-extra.is-open').forEach(function (i) { i.classList.remove('is-open'); });
    } else if ((b = e.target.closest('[data-ch-ing-tab]'))) {
      var ing = b.closest('.ch-ing'), idx = b.getAttribute('data-ch-ing-tab');
      ing.querySelectorAll('[data-ch-ing-tab]').forEach(function (x) {
        x.classList.toggle('is-active', x === b);
        x.setAttribute('aria-selected', x === b ? 'true' : 'false');
      });
      ing.querySelectorAll('[data-ch-ing-item]').forEach(function (x) {
        x.classList.toggle('is-active', x.getAttribute('data-ch-ing-item') === idx);
      });
    } else if ((b = e.target.closest('[data-ch-shop-prev],[data-ch-shop-next]'))) {
      var s = b.closest('.ch-shop'), g = s.querySelector('[data-ch-shop-track]');
      g.scrollBy({ left: b.hasAttribute('data-ch-shop-next') ? 190 : -190, behavior: 'smooth' });
    }
  });

  function init() {
    fitHero();
    document.querySelectorAll('.ch-shop').forEach(function (sec) {
      var g = sec.querySelector('[data-ch-shop-track]');
      if (!g || g.__chBound) return;
      g.__chBound = true;
      g.addEventListener('scroll', function () { updateArrows(sec); }, { passive: true });
      updateArrows(sec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (document.fonts) {
    document.fonts.ready.then(fitHero);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitHero);
  }
  var to;
  window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(fitHero, 100); });
  // Re-run when sections are edited in the theme customiser.
  document.addEventListener('shopify:section:load', init);
})();
